import Helper from 'src/helper/Helper';
import React, { useEffect } from 'react';
import System from 'src/helper/system';
import ProductLegends from 'src/pages/ProductListing/ProductLegends';
import noImage from 'src/assets/images/noimage.png'
import redAlert from 'src/assets/images/red-alert.svg'
import { useCartStore } from 'src/hooks/cart';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import { __set, __remove } from "src/store/axios_indicator";
import { useOrderStore } from 'src/hooks/order';
import { Beacon } from 'src/component/Global/Beacon';
import useReduxState from 'src/hooks/useReduxState';
import Constants from 'src/helper/Constants';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useSystem } from "src/hooks/system";

const CheckoutCartList = (props) => {
    const [{ CART_DATA, CART_PRODUCTS: products }, { fetch_cart_data }, { }] = useCartStore();
    const [__check] = useAxiosIndicatorCheck();
    const [{ validate_order_from_server }, { }, { }] = useOrderStore()
    const cartProductData = JSON.parse(localStorage.getItem(System.storageName.CART_PRODUCT_DATA))
    const [checkoutData] = useReduxState({}, 'setCheckoutData')
    const { currencyType: { USD } } = Constants
    const [{ }, { get_inventory_by_id }, { }] = useProductInventoryPriceStore();
    const [, { get_quantity_format }] = useSystem();

    useEffect(() => {
        async function fetchData() {
            __set('VIEW_CART_API_CALL');
            await fetch_cart_data()
            __remove('VIEW_CART_API_CALL');

        }
        fetchData()
    }, []);

    useEffect(() => {
        if (Object.keys(CART_DATA).length) {
            let prodDetails = [];
            Object.entries(CART_DATA).map((data, i) => {
                prodDetails.push(data[1]);
            })
            prodDetails.forEach((data, key) => {
                let copyObj = { ...data };
                copyObj.qas = get_inventory_by_id(copyObj.ItemNumber || copyObj.itemNumber)?.inventoryQty || copyObj.quantity;
                prodDetails[key] = copyObj;
            })
            let cartDetails = {
                "cartType": "checkout"
            }
            localStorage.setItem("adobeEventType", "cartCheckout");
            if (Object.keys(prodDetails).length) {
                HelperAdobeEvent.trackingAdobeEvent({ prodDetails, cartDetails });
            }
        }
    }, [CART_DATA])

    const eligibleShipping = (v) => {
        let validateShipMessage = false
        validate_order_from_server?.cartItems?.forEach(ele => {
            if (ele.itemNumber === v.itemNumber && ele.isEligibleShipping === false) {
                validateShipMessage = true
            }
        });
        return validateShipMessage
    }

    const isSupplierRestriction = (v) => {
        let validateShipMessage = false
        validate_order_from_server?.cartItems?.forEach(ele => {
            if (ele.itemNumber === v.itemNumber && ele.isSupplierRestricted === true) {
                validateShipMessage = true
            }
        });
        return validateShipMessage
    }

    const getAvailableQuantity = (v) => {
        if (v && v?.scheduleDetails?.length) {
            let sum = 0;
            v?.scheduleDetails?.forEach(ele => {
                sum += ele.quantity;
            });

            return v.quantity - sum
        }
    }
    return (
        <>
            {Object.entries(CART_DATA || {})?.find((item) => products[item[1]?.itemNumber]?.SoftwareDownloadFlag) && <div className="accordion accordion-with-arrow mycart-accordion mb-3 mt-3" id="mycart-accordion">
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <button id="collapseTwo" className="accordion-button font-16 collapsed" type="button" data-toggle="collapse" data-target="#collapseSoftware" aria-expanded="false" aria-controls="collapseSoftware">
                            Downloadable Software(s)
                        </button>
                    </h2>
                    <div id="collapseSoftware" className={'accordion-collapse collapse'} aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <div className="table-responsive">
                                {(__check(['VIEW_CART_API_CALL', 'CART_API_CALL']).render) ? <AxiosIndicatorRunTimeLoader /> :
                                    <table className="mycart-table" width="100%">
                                        <tbody>
                                            {Object.entries(CART_DATA)?.length > 0 &&
                                                Object.entries(CART_DATA)?.filter((item) => products[item[1]?.itemNumber]?.SoftwareDownloadFlag)?.map((v, i) => (
                                                    <tr key={i}>
                                                        <td className="acc-product-img">
                                                            <div className="product-info nopadding">
                                                                <span className='checkout-item-count'>Item: {i + 1}</span>
                                                                <div className="product-img sect-1 text-center">
                                                                    <img src={(Helper.valueIsNotNull(v[1].assetURL))
                                                                        ? v[1].assetURL
                                                                        : noImage} alt='Product' />
                                                                </div>
                                                            </div>
                                                            <div className="prod-option-icon sect-2">
                                                                <div className="d-flex justify-content-start">
                                                                    <ProductLegends
                                                                        single_product={cartProductData[v[0]]}
                                                                        onlyIcon={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="acc-product-name">
                                                            <>
                                                                <strong>{cartProductData[v[0]]?.ERPMFRPartNumber}</strong> <br />
                                                                {v[1].manufacturerName !== undefined &&
                                                                    <div>
                                                                        <span> by </span>
                                                                        {v[1].manufacturerName ? v[1].manufacturerName : ''}
                                                                    </div>
                                                                }

                                                                <strong>{v[1].cpn}</strong>
                                                                {products[v[1]?.itemNumber]?.SoftwareDownloadFlag &&
                                                                    <div className="mt-2 font-arial">
                                                                        <b> In Stock downloadable</b>
                                                                    </div>
                                                                }

                                                                {eligibleShipping(v[1]) && (
                                                                    <p className="error">
                                                                        Unable to ship to the country selected
                                                                    </p>
                                                                )}

                                                                {isSupplierRestriction(v[1]) && (
                                                                    <div className="d-flex">
                                                                        <img src={redAlert} />
                                                                        <p className="error m-l-05 m-t-10">
                                                                            Restricted Item.
                                                                        </p>
                                                                    </div>
                                                                )}

                                                            </>
                                                        </td>
                                                        <td>

                                                            <div className='acc-download-instructions'>
                                                                Download Instructions:<br />
                                                                <b>Your order is being processed. The link to download your software from this order will be sent to the user entitled to this license in a separate email. Please make sure that notification@flexera.com is in the users safe sender list so that the email is not blocked.</b>
                                                            </div>
                                                            <div className='d-flex justify-content-end print-wrap me-1 mt-2'>
                                                                <div className="acc-product-info">

                                                                    <div className="mb-3">
                                                                        {v[1].scheduleDetails.length > 0 &&
                                                                            <>
                                                                                <span className="">Scheduled Dates:</span>
                                                                                <div className="sceduledate-list border-bottom1 mb-1">
                                                                                    <div className="d-flex  border-bottom1 justify-content-between">
                                                                                        <div className="col-4 ps-0">Quantity</div>
                                                                                        <div className="col-8 pe-0 text-end">Ship Date</div>
                                                                                    </div>
                                                                                    {getAvailableQuantity(v[1]) > 0 ?
                                                                                        <div className="bs5 row m-0">
                                                                                            <div className="col-4 ps-0">{get_quantity_format(getAvailableQuantity(v[1]))}</div>
                                                                                            <div className="col-8 pe-0 text-end">
                                                                                                As Available
                                                                                            </div>
                                                                                        </div> : null}
                                                                                    {v[1].scheduleDetails.map((p, j) => (
                                                                                        <div className="bs5 row m-0" key={j}>
                                                                                            <div className="col-4 ps-0">{get_quantity_format(p.quantity)}</div>
                                                                                            <div className="col-8 pe-0 text-end">
                                                                                                {Helper.dateFormatFromString(p.scheduledDate)}
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="acc-product-total">

                                                                    <div className="bs5 row">
                                                                        <div className="col-5">Unit Price:</div>
                                                                        <div className="col-7 text-end text-right"><strong>{System.getFormatNumber({ amount: checkoutData?.billingCurrency == USD ? Number(v[1].unitPrice) : (Number(v[1].unitPrice * checkoutData?.rateOfExchange)), currency: v[1].currency })}</strong></div>
                                                                    </div>
                                                                    <div className="bs5 row">
                                                                        <div className="col-5">Subtotal:</div>
                                                                        <div className="col-7 text-end"><strong>{System.getFormatNumber({ amount: checkoutData?.billingCurrency == USD ? Number(v[1].subtotal) : Number(v[1].subtotal * checkoutData?.rateOfExchange), currency: v[1].currency, maximumFractionDigits: 2 })}</strong></div>
                                                                    </div>
                                                                    <div className="bs5 row">
                                                                        <div className="col-5">Quantity:</div>
                                                                        <div className="col-7 text-end text-right"><strong>{get_quantity_format(Number(v[1].quantity))}</strong></div>
                                                                    </div>
                                                                    <div className={v[1].backOrderedQuantity > 0 ? "bs5 row mt-2" : "bs5 row d-none"}>
                                                                        <div className="col-5 position-relative">
                                                                            <Beacon position={"left"} content={() => "This is the number of parts that have been backordered. Supplier Lead time will apply to the backordered parts."}
                                                                                opener={() => (
                                                                                    <div className="becon-dot"></div>
                                                                                )} />Backordered:</div>
                                                                        <div className="col-7 text-end"><strong>{get_quantity_format(Number(v[1].backOrderedQuantity))}</strong></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div >}
            {Object.entries(CART_DATA || {})?.find((item) => !products[item[1]?.itemNumber]?.SoftwareDownloadFlag) && <div className="accordion accordion-with-arrow mycart-accordion mb-3 mt-3" id="mycart-accordion">
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne2">
                        <button id="collapseTwo" className="accordion-button font-16 collapsed" type="button" data-toggle="collapse" data-target="#collapseCart" aria-expanded="false" aria-controls="collapseCart">
                            My Cart
                        </button>
                    </h2>
                    <div id="collapseCart" className={'accordion-collapse collapse'} aria-labelledby="headingOne2" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <div className="table-responsive">
                                {(__check(['VIEW_CART_API_CALL', 'CART_API_CALL']).render) ? <AxiosIndicatorRunTimeLoader /> :
                                    <table className="mycart-table" width="100%">
                                        <tbody>
                                            {
                                                Object.entries(CART_DATA)?.filter((item) => !products[item[1]?.itemNumber]?.SoftwareDownloadFlag)?.map((v, i) => (
                                                    <tr key={i}>
                                                        <td className="acc-product-img">
                                                            <div className="product-info nopadding">
                                                                <span className='checkout-item-count'>Item: {i + 1}</span>
                                                                <div className="product-img sect-1 text-center">
                                                                    <img src={(Helper.valueIsNotNull(v[1].assetURL))
                                                                        ? v[1].assetURL
                                                                        : noImage} alt='Product' />
                                                                </div>
                                                            </div>
                                                            <div className="prod-option-icon sect-2">
                                                                <div className="d-flex justify-content-start">
                                                                    <ProductLegends
                                                                        single_product={cartProductData[v[0]]}
                                                                        onlyIcon={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="acc-product-name">
                                                            <>
                                                                <strong>{cartProductData[v[0]]?.ERPMFRPartNumber}</strong> <br />
                                                                {v[1].manufacturerName !== undefined &&
                                                                    <div>
                                                                        <span> by </span>
                                                                        {v[1].manufacturerName ? v[1].manufacturerName : ''}
                                                                    </div>
                                                                }

                                                                <strong>{v[1].cpn}</strong>

                                                                {eligibleShipping(v[1]) && (
                                                                    <p className="error">
                                                                        Unable to ship to the country selected
                                                                    </p>
                                                                )}

                                                                {isSupplierRestriction(v[1]) && (
                                                                    <div className="d-flex">
                                                                        <img src={redAlert} />
                                                                        <p className="error m-l-05 m-t-10">
                                                                            Restricted Item.
                                                                        </p>
                                                                    </div>
                                                                )}

                                                            </>
                                                        </td>
                                                        <td className="acc-product-info">
                                                            <div className="mb-3">
                                                                {v[1].scheduleDetails.length > 0 &&
                                                                    <>
                                                                        <span className="">Scheduled Dates:</span>
                                                                        <div className="sceduledate-list border-bottom1 mb-1">
                                                                            <div className="d-flex  border-bottom1 justify-content-between">
                                                                                <div className="col-4 ps-0">Quantity</div>
                                                                                <div className="col-8 pe-0 text-end">Ship Date</div>
                                                                            </div>
                                                                            {getAvailableQuantity(v[1]) > 0 ?
                                                                                <div className="bs5 row m-0">
                                                                                    <div className="col-4 ps-0">{get_quantity_format(getAvailableQuantity(v[1]))}</div>
                                                                                    <div className="col-8 pe-0 text-end">
                                                                                        As Available
                                                                                    </div>
                                                                                </div> : null}
                                                                            {v[1].scheduleDetails.map((p, j) => (
                                                                                <div className="bs5 row m-0" key={j}>
                                                                                    <div className="col-4 ps-0">{get_quantity_format(p.quantity)}</div>
                                                                                    <div className="col-8 pe-0 text-end">
                                                                                        {Helper.dateFormatFromString(p.scheduledDate)}
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>

                                                        </td>
                                                        <td className="acc-product-total">
                                                            <div className="bs5 row">
                                                                <div className="col-4">Unit Price:</div>
                                                                <div className="col-8 text-end text-right"><strong>{System.getFormatNumber({ amount: checkoutData?.billingCurrency == USD ? Number(v[1].unitPrice) : (Number(v[1].unitPrice * checkoutData?.rateOfExchange)), currency: v[1].currency })}</strong></div>
                                                            </div>
                                                            <div className="bs5 row">
                                                                <div className="col-4">Subtotal:</div>
                                                                <div className="col-8 text-end"><strong>{System.getFormatNumber({ amount: checkoutData?.billingCurrency == USD ? Number(v[1].subtotal) : Number(v[1].subtotal * checkoutData?.rateOfExchange), currency: v[1].currency, maximumFractionDigits: 2 })}</strong></div>
                                                            </div>
                                                            <div className="bs5 row">
                                                                <div className="col-4">Quantity:</div>
                                                                <div className="col-8 text-end text-right"><strong>{get_quantity_format(Number(v[1].quantity))}</strong></div>
                                                            </div>
                                                            <div className={v[1].backOrderedQuantity > 0 ? "bs5 row mt-3" : "bs5 row d-none"}>
                                                                <div className="col-5 position-relative">
                                                                    <Beacon position={"left"} content={() => "This is the number of parts that have been backordered. Supplier Lead time will apply to the backordered parts."}
                                                                        opener={() => (
                                                                            <div className="becon-dot"></div>
                                                                        )} />Backordered:</div>
                                                                <div className="col-7 text-end"><strong>{get_quantity_format(Number(v[1].backOrderedQuantity))}</strong></div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div >}
        </>
    );
}

export default CheckoutCartList;
